import 'antd/lib/dropdown/style/index.css'
import { StyledDropdown } from './style'

export default StyledDropdown
